import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import conversationService from '../../services/conversationService';

export const fetchConversations = createAsyncThunk('conversations/fetch', async (filters, thunkAPI) => {
  try { return await conversationService.list(filters || {}); } catch (err) { return thunkAPI.rejectWithValue(err.response?.data?.message || err.message); }
});
export const createConversation = createAsyncThunk('conversations/create', async (payload, thunkAPI) => {
  try { return await conversationService.create(payload); } catch (err) { return thunkAPI.rejectWithValue(err.response?.data?.message || err.message); }
});
export const updateConversation = createAsyncThunk('conversations/update', async ({ id, payload }, thunkAPI) => {
  try { return await conversationService.update(id, payload); } catch (err) { return thunkAPI.rejectWithValue(err.response?.data?.message || err.message); }
});

const initialState = {
  list: [],
  filters: { page: 1, limit: 20, inbox: 'support' },
  pagination: { totalPages: 0, currentPage: 1, total: 0 },
  selectedId: null,
  isLoading: false,
  isError: false,
  message: '',
};

const conversationsSlice = createSlice({
  name: 'conversations',
  initialState,
  reducers: {
    setFilters(state, action) { state.filters = { ...state.filters, ...(action.payload || {}) }; },
    selectConversation(state, action) { state.selectedId = action.payload || null; },
    socketUpsertConversation(state, action) {
      const c = action.payload; if (!c?._id) return;
      const idx = state.list.findIndex(x => x._id === c._id);
      if (idx >= 0) state.list[idx] = { ...state.list[idx], ...c }; else state.list.unshift(c);
    },
    removeConversation(state, action) {
      const id = typeof action.payload === 'string' ? action.payload : action.payload?.id;
      if (!id) return;
      state.list = state.list.filter(c => c._id !== id);
      if (state.selectedId === id) {
        state.selectedId = state.list[0]?._id || null;
      }
    },
  },
  extraReducers: (b) => {
    b
      .addCase(fetchConversations.pending, (s)=>{ s.isLoading = true; s.isError = false; s.message=''; })
      .addCase(fetchConversations.fulfilled, (s, a)=>{ s.isLoading=false; const { conversations, totalPages, currentPage, total } = a.payload; s.list = conversations||[]; s.pagination = { totalPages, currentPage, total }; })
      .addCase(fetchConversations.rejected, (s, a)=>{ s.isLoading=false; s.isError=true; s.message=a.payload||'Failed to load conversations'; })
      .addCase(createConversation.fulfilled, (s, a)=>{ s.list.unshift(a.payload); })
      .addCase(updateConversation.fulfilled, (s, a)=>{ const i = s.list.findIndex(x=>x._id===a.payload._id); if(i>=0) s.list[i]=a.payload; });
  }
});

export const { setFilters, selectConversation, socketUpsertConversation, removeConversation } = conversationsSlice.actions;
export default conversationsSlice.reducer;
